import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  FiInfo,
  FiAward,
  FiUsers,
  FiTrendingUp,
  FiShield,
  FiTarget,
  FiBarChart,
  FiCheckCircle,
  FiBriefcase
} from 'react-icons/fi';
import './About.css';

const About = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('intro');

  useEffect(() => {
    const hash = location.hash.replace('#', '');
    if (hash) setActiveTab(hash);
  }, [location]);

  const numbers = [
    { value: '15年', label: '行业深耕', desc: '持续服务政府、央国企、上市公司' },
    { value: '38名', label: '注册造价工程师', desc: '12名高级工程师  /  6 名合伙人' },
    { value: '500亿+', label: '年度服务金额', desc: '全过程造价 · 审计 · 招投标' },
    { value: '92%', label: '客户续约率', desc: '以结果交付和口碑驱动持续合作' }
  ];

  const milestones = [
    { year: '2013', title: '识道造价事务所成立', desc: '在宁波创立，聚焦工程造价咨询与招标代理服务，立足浙江，服务全国。' },
    { year: '2016', title: '获取双甲级资质', desc: '取得工程造价咨询甲级、招标代理甲级资质，服务范围覆盖全国。' },
    { year: '2019', title: '自研AI审核引擎', desc: '成立数智研究院，发布AI图纸识别与智能算量系统。' },
    { year: '2021', title: 'BIM+造价一体化平台上线', desc: '为央国企、地方国资平台提供数字化造价解决方案。' },
    { year: '2024', title: '全过程造价管控中枢落地', desc: '构建“数据中枢+应用层”，支撑集团化多项目成本治理。' }
  ];

  const values = [
    {
      icon: <FiShield />,
      title: '专业 / Professional',
      desc: '以注册造价工程师、审计师、招标师为核心的专家团队，提供全方位专业支撑。'
    },
    {
      icon: <FiTarget />,
      title: '价值导向 / Value-Oriented',
      desc: '以结果为导向设计交付物，所有阶段服务都可度量、可复用、可沉淀。'
    },
    {
      icon: <FiTrendingUp />,
      title: '创新驱动 / Innovative',
      desc: '自研AI审核、BIM协同、全过程管控平台，推动造价治理数智化升级。'
    }
  ];

  const leadership = [
    { name: '徐总', title: '创始人兼 CEO', desc: '某知名事务所负责人，主导多个大型数字化项目' },
    { name: '熊经理', title: '技术总监', desc: '某大学知名教授，专注云原生与数据中台设计' },
    { name: '金专家', title: '行业顾问', desc: '20 年工程管理经验，熟悉大型基建与市政项目流程' }

  ];

  return (
    <main className="about-page">
      <section className="about-hero">
        <div className="container">
          <div className="hero-content">
            <div>
              <span className="hero-eyebrow">WHO WE ARE · 宁波</span>
              <h1>识道造价事务所 · 立足宁波的专业造价服务机构</h1>
              <p>
                2013年成立于宁波，深耕长三角造价市场15年。我们以"全过程造价咨询 + AI 智能审核 + BIM数据中枢"为核心能力，
                为浙江及全国的政府、央国企、社会投资机构提供可落地的造价治理方案。
              </p>
            </div>
            <div className="hero-numbers">
              {numbers.map((item, index) => (
                <div key={index} className="number-card">
                  <span className="number-value">{item.value}</span>
                  <span className="number-label">{item.label}</span>
                  <p>{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="about-tabs">
        <div className="container">
          <div className="tab-list" style={{ flexDirection: 'row' }}>
            <button
              className={`tab-item ${activeTab === 'intro' ? 'active' : ''}`}
              onClick={() => setActiveTab('intro')}
            >
              <FiInfo />
              <span>公司简介</span>
            </button>
            <button
              className={`tab-item ${activeTab === 'qualifications' ? 'active' : ''}`}
              onClick={() => setActiveTab('qualifications')}
            >
              <FiAward />
              <span>资质与荣誉</span>
            </button>
            <button
              className={`tab-item ${activeTab === 'team' ? 'active' : ''}`}
              onClick={() => setActiveTab('team')}
            >
              <FiUsers />
              <span>团队与文化</span>
            </button>
          </div>
        </div>
      </section>

      <section className="about-content">
        <div className="container">
          {activeTab === 'intro' && (
            <div className="content-section">
              <div className="section-header">
                <h2>我们是谁</h2>
                <p>
                  识道造价于 2013 年成立于宁波，深耕长三角市场15年，持续为浙江及全国的政府、央国企、头部民企提供专业的工程造价咨询、招标代理、造价数据治理服务。
                  我们相信造价治理不仅关乎数字，更关乎企业的投资决策力、资金管控力与运营效率。
                </p>
              </div>

              <div className="values-grid">
                {values.map((value, index) => (
                  <div key={index} className="value-card">
                    <div className="value-icon">{value.icon}</div>
                    <h3>{value.title}</h3>
                    <p>{value.desc}</p>
                  </div>
                ))}
              </div>

              <div className="timeline">
                {milestones.map((milestone, index) => (
                  <div key={index} className="timeline-item">
                    <div className="timeline-year">{milestone.year}</div>
                    <div className="timeline-content">
                      <h4>{milestone.title}</h4>
                      <p>{milestone.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'qualifications' && (
            <div className="content-section">
              <div className="section-header">
                <h2>资质 · 荣誉 · 认可</h2>
                <p>
                  我们以资质为基础、以荣誉为背书、以客户认可为目标，持续夯实专业能力。
                </p>
              </div>
              <div className="qualifications-grid">
                <div className="qualification-card">
                  <FiCheckCircle />
                  <h3>工程造价咨询甲级资质</h3>
                  <p>覆盖全过程造价咨询、造价鉴定、造价审计服务。</p>
                </div>
                <div className="qualification-card">
                  <FiCheckCircle />
                  <h3>中央投资项目招标代理甲级</h3>
                  <p>具备大型复杂项目招标组织与合规审核能力。</p>
                </div>
                <div className="qualification-card">
                  <FiCheckCircle />
                  <h3>国家高新技术企业</h3>
                  <p>拥有AI审核引擎、BIM平台、成本管控平台等自主知识产权。</p>
                </div>
                <div className="qualification-card">
                  <FiCheckCircle />
                  <h3>ISO9001 · ISO27001 等体系认证</h3>
                  <p>质量管理、信息安全管理体系完备，满足政企数据安全要求。</p>
                </div>
              </div>

              <div className="honor-board">
                <div className="honor-item">
                  <FiTrendingUp />
                  <div>
                    <strong>年度行业影响力机构</strong>
                    <p>中国工程造价咨询协会评选</p>
                  </div>
                </div>
                <div className="honor-item">
                  <FiBriefcase />
                  <div>
                    <strong>央国企优秀供应商</strong>
                    <p>多家央企、地方国资平台优秀服务商称号</p>
                  </div>
                </div>
                <div className="honor-item">
                  <FiBarChart />
                  <div>
                    <strong>数智化标杆案例</strong>
                    <p>造价行业数字化转型典型案例</p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'team' && (
            <div className="content-section">
              <div className="section-header">
                <h2>团队与文化</h2>
                <p>
                  专业多元的团队结构是识道的核心资产。我们拥有造价、审计、招标、法务、技术等跨学科人才，并以“专业、共创、共赢”的文化连接彼此。
                </p>
              </div>

              <div className="team-grid">
                {leadership.map((leader, index) => (
                  <div key={index} className="leader-card">
                    <div className="leader-avatar">{leader.name.slice(0, 1)}</div>
                    <div>
                      <h3>{leader.name}</h3>
                      <span>{leader.title}</span>
                      <p>{leader.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="culture-board">
                <div className="culture-item">
                  <h4>专家体系</h4>
                  <p>覆盖造价、招标、审计、AI、BIM等核心能力，形成复合型服务团队。</p>
                </div>
                <div className="culture-item">
                  <h4>方法论沉淀</h4>
                  <p>打造“标准化交付+定制化咨询”的方法库，保障成果复用与复制。</p>
                </div>
                <div className="culture-item">
                  <h4>共创协同</h4>
                  <p>设立客户联合创新项目，与合作伙伴共建造价治理新模式。</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
    </main>
  );
};

export default About;
